import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import MessageList from './components/MessageList';
import t from '../../lib/translate';
import MessageSearch from './hooks/MessageSearch';
import SearchFilter from './components/SearchFilter';
import InfoBox from '../../components/InfoBox';
var MessagePage = function () {
    return (_jsxs("div", { children: [_jsx("h1", { children: t('messages.header') }), _jsx(InfoBox, { label: t('general.info'), text: t('messages.search.info') }), _jsx("br", {}), _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsxs(MessageSearch.Provider, { children: [_jsx(SearchFilter, {}), _jsx(MessageList, {})] }) }) })] }));
};
export default MessagePage;
